module.exports = __webpack_public_path__ + "static/media/battlefield.d835b776.mp3";